import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';
//import 'jquery-components/bootstrap-datepicker';
import $ from 'jquery';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { language } from '../appI18n';
import { attachSingleDateCalendar } from '../calendar/attachSingleDateCalendar';
import isEqual from 'lodash/isEqual';
const InputValidationMessage = (message, ref) => {
    return {
        onInvalid: () => {
            var _a;
            if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity)
                ref.current.setCustomValidity(message);
        },
        onChange: () => {
            var _a;
            if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity)
                ref.current.setCustomValidity('');
        }
    };
};
export function BootstrapDatePicker(props) {
    var _a;
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    //const displayValue = useMemo(() => props.selected ? ($.fn.datepicker as any).DPGlobal.format(props.selected.toDate().toLocaleDateString(), ($.fn.datepicker as any).defaults.format, language) : undefined, [props.selected])
    //const displayValue = useMemo(() => props.selected ? props.selected.toDate().toLocaleDateString() : undefined, [props.selected])
    useEffect(() => {
        if (!containerRef.current)
            return;
        $(containerRef.current).datepicker(Object.assign({ language: language, 
            //format: 'yyyy-mm-dd',
            startDate: new Date(), orientation: "bottom auto", todayHighlight: true, autoclose: true, keepEmptyValues: true }, (props.datepickerOptions || {})));
        $(containerRef.current).off('clearDate');
        $(containerRef.current).off('changeDate');
        $(containerRef.current).on('clearDate', (e) => {
            if (props.onChange)
                props.onChange(undefined);
        });
        $(containerRef.current).on('changeDate', (e) => {
            if (props.onChange) {
                //props.onChange(e.date ? e.date.toISOString().split('T')[0] : undefined)
                //props.onChange(e.date ? moment(e.date).toDate().toLocaleDateString() : undefined)
                //props.onChange(moment(e.date))
                props.onChange(e.format());
            }
        });
    }, [containerRef.current, props.datepickerOptions]);
    //useEffect(() => {
    //    if (!inputRef.current)
    //        return
    //    $(inputRef.current).selectpicker('refresh')
    //}, [props.disabled, props.required])
    useEffect(() => {
        if (!containerRef.current)
            return;
        $(containerRef.current).datepicker('setDate', props.selected);
        $(containerRef.current).datepicker('refresh');
    }, [props.selected, containerRef.current]);
    //useEffect(() => {
    //    if (!containerRef.current)
    //        return
    //    //$(containerRef.current).datepicker('setDate', props.selected as any)
    //    $(containerRef.current).datepicker('setDate', props.selected?.format((props.datepickerOptions?.format || 'mm/dd/yyyy').toString().toUpperCase()) as any)
    //    setTimeout(() => {
    //        $(containerRef.current!).datepicker('refresh')
    //    }, 200)
    //}, [props.selected, containerRef.current])
    //useEffect(() => {
    //    if (!selectRef.current)
    //        return
    //    $(selectRef.current).selectpicker('refresh')
    //})
    return (React.createElement("div", { className: "input-group date", ref: containerRef },
        React.createElement("label", { htmlFor: "date", className: "input-group-addon input-date datepickerbutton" }),
        React.createElement("input", Object.assign({ ref: inputRef, type: "text", className: "form-control px-0", required: true, maxLength: 10 }, (props.customValidationMessage ? InputValidationMessage(props.customValidationMessage, inputRef) : {}), { value: typeof props.selected == 'string' ? props.selected : (_a = props.selected) === null || _a === void 0 ? void 0 : _a.toISOString().split('T')[0], autoComplete: "off" }, (props.inputProps || {}))),
        React.createElement("label", { htmlFor: "date", className: "input-group-addon datepickerbutton" },
            React.createElement("span", { className: "input-select glyphicon glyphicon-calendar" }))));
}
export function BootstrapDatetimePicker(props) {
    var _a, _b, _c, _d, _e;
    const inputRef = useRef(null);
    const pickerRef = useRef();
    const maskRef = useRef();
    const selectedValue = (_b = (_a = props.selected) === null || _a === void 0 ? void 0 : _a.format('DD.MM.YYYY')) !== null && _b !== void 0 ? _b : '';
    const [inputValue, setInputValue] = React.useState(selectedValue);
    const propsRef = useRef(props);
    propsRef.current = props;
    const pickerOptions = () => {
        var _a, _b, _c, _d, _e, _f;
        return ({
            selected: propsRef.current.selected,
            minDate: (_b = (_a = propsRef.current.datepickerOptions) === null || _a === void 0 ? void 0 : _a.minDate) !== null && _b !== void 0 ? _b : propsRef.current.minDate,
            maxDate: (_d = (_c = propsRef.current.datepickerOptions) === null || _c === void 0 ? void 0 : _c.maxDate) !== null && _d !== void 0 ? _d : propsRef.current.maxDate,
            isDateDisabled: (date) => {
                var _a;
                const disabledDates = (_a = propsRef.current.datepickerOptions) === null || _a === void 0 ? void 0 : _a.disabledDates;
                return !!disabledDates && disabledDates.some(disabled => date.isSame(moment(disabled), 'day'));
            },
            format: 'DD.MM.YYYY',
            allowShortYear: ((_e = propsRef.current.mask) === null || _e === void 0 ? void 0 : _e[0]) === '0Z.0Z.00ZZ',
            disabled: propsRef.current.disabled || ((_f = propsRef.current.inputProps) === null || _f === void 0 ? void 0 : _f.disabled),
            invalidMessage: propsRef.current.customValidationMessage,
            onChange: (selected) => {
                var _a, _b, _c;
                setInputValue((_a = selected === null || selected === void 0 ? void 0 : selected.format('DD.MM.YYYY')) !== null && _a !== void 0 ? _a : '');
                (_c = (_b = propsRef.current).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, selected);
            },
        });
    };
    useEffect(() => {
        if (!inputRef.current)
            return;
        pickerRef.current = attachSingleDateCalendar(inputRef.current, pickerOptions());
        return () => { var _a; return (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.destroy(); };
    }, []);
    useEffect(() => {
        var _a;
        (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.update(pickerOptions());
    });
    useEffect(() => {
        setInputValue(selectedValue);
    }, [selectedValue]);
    useEffect(() => {
        if (!inputRef.current)
            return;
        // Callers pass a fresh tuple/options object on every parent render.
        // Rebinding an equivalent mask loses its caret history while its timer is pending.
        if (isEqual(maskRef.current, props.mask))
            return;
        const input = $(inputRef.current);
        input.unmask();
        maskRef.current = props.mask;
        if (props.mask) {
            input.mask(...props.mask);
            // Autofill/paste can emit input without keydown. The plugin otherwise
            // leaves maskDigitPosMapOld undefined for its delayed caret calculation.
            input.triggerHandler('keydown.mask');
        }
    });
    useEffect(() => {
        const input = inputRef.current;
        return () => { if (input)
            $(input).unmask(); };
    }, []);
    const handleInputChange = (event) => {
        var _a, _b;
        setInputValue(event.currentTarget.value);
        event.currentTarget.setCustomValidity('');
        (_b = (_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    };
    return (React.createElement("div", { className: "input-group date" },
        React.createElement("label", { htmlFor: props.id, className: "input-group-addon input-date" }),
        React.createElement("input", Object.assign({ ref: inputRef, id: props.id, type: "text", required: (_c = props.required) !== null && _c !== void 0 ? _c : true, disabled: props.disabled, maxLength: 10 }, (props.customValidationMessage ? InputValidationMessage(props.customValidationMessage, inputRef) : {}), { value: inputValue, autoComplete: "off" }, (props.inputProps || {}), { onChange: handleInputChange, className: `form-control ${(_e = (_d = props.inputProps) === null || _d === void 0 ? void 0 : _d.className) !== null && _e !== void 0 ? _e : ''}` }))));
}
